import { useState, useEffect } from "react";
import { ProSidebar, Menu, MenuItem } from "react-pro-sidebar";
import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { tokens } from "../../theme";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import {
  CarRental,
  AccountBox,
  ReceiptLong,
  DocumentScanner,
  AddLocation,
  AttachMoney,
  Construction,
  PostAdd,
  PointOfSale,
  Campaign,
  Dashboard,
} from "@mui/icons-material";

const Item = ({ title, to, icon, selected, setSelected }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => setSelected(title)}
      icon={icon}
    >
      <Typography>{title}</Typography>
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [selected, setSelected] = useState();

  useEffect(() => {
    const setHeight = () => {
      const fullHeight = Math.max(
        document.body.scrollHeight,
        document.documentElement.scrollHeight
      );

      document.getElementById("mySidebar").style.height = `${fullHeight - 1}px`;
    };

    setHeight();

    const resizeListener = () => setHeight();
    window.addEventListener("resize", resizeListener);

    const observer = new MutationObserver(setHeight);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("resize", resizeListener);
      observer.disconnect();
    };
  }, []);

  return (
    <div id="mySidebar" style={{ display: "flex" }}>
      <Box
        sx={{
          "& .pro-sidebar-inner": {
            background: `${colors.primary[400]} !important`,
            flexGrow: 1,
          },
          "& .pro-icon-wrapper": {
            backgroundColor: "transparent !important",
          },
          "& .pro-inner-item": {
            padding: "5px 30px 5px 20px !important",
          },
          "& .pro-inner-item:hover": {
            color: "#868dfb !important",
          },
          "& .pro-menu-item.active": {
            color: "#6870fa !important",
          },
        }}
      >
        <ProSidebar collapsed={isCollapsed}>
          <Menu iconShape="square">
            <MenuItem
              onClick={() => setIsCollapsed(!isCollapsed)}
              icon={isCollapsed ? <MenuOutlinedIcon /> : undefined}
              style={{
                margin: "10px 0 20px 0",
                color: colors.grey[100],
              }}
            >
              {!isCollapsed && (
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  ml="15px"
                >
                  <Typography variant="h3" color={colors.grey[100]}>
                    Gestion de location
                  </Typography>
                  <IconButton onClick={() => setIsCollapsed(!isCollapsed)}>
                    <MenuOutlinedIcon />
                  </IconButton>
                </Box>
              )}
            </MenuItem>

            {!isCollapsed && (
              <Box mb="25px">
                {/* <Box display="flex" justifyContent="center" alignItems="center">
                  <img
                    alt="profile-user"
                    width="100px"
                    height="100px"
                    src={`../../assets/user.png`}
                    style={{ cursor: "pointer", borderRadius: "50%" }}
                  />
                </Box> */}
                <Box textAlign="center">
                  <Typography
                    variant="h2"
                    color={colors.grey[100]}
                    fontWeight="bold"
                    sx={{ m: "10px 0 0 0" }}
                  ></Typography>
                </Box>
              </Box>
            )}
            <Item
              title="Dashboard"
              to="/dashboard"
              icon={<Dashboard />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Voiture"
              to="/voiture"
              icon={<CarRental />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Etat"
              to="/etat"
              icon={<Construction />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Papier"
              to="/papier"
              icon={<PostAdd />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Conducteur"
              to="/conducteur"
              icon={<AccountBox />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Contrat"
              to="/contrat"
              icon={<ReceiptLong />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Paiement"
              to="/paiement"
              icon={<AttachMoney />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Charges"
              to="/charge"
              icon={<PointOfSale />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Alerts"
              to="/alert"
              icon={<Campaign />}
              selected={selected}
              setSelected={setSelected}
            />
            <Item
              title="Document"
              to="/document"
              icon={<DocumentScanner />}
              selected={selected}
              setSelected={setSelected}
            />
          </Menu>
        </ProSidebar>
      </Box>
    </div>
  );
};

export default Sidebar;
